const articleContext = ['articlepage', 'articlePaywallPage', 'articlePreviewPage', 'infoArticle'];
export const isArticlePage = pageContext => articleContext.includes(pageContext.type);
